import u from "./ghl-ui.es1543.js";
import l from "./ghl-ui.es1544.js";
import n from "./ghl-ui.es1540.js";
import c from "./ghl-ui.es1541.js";
import h from "./ghl-ui.es1542.js";
import m from "./ghl-ui.es1545.js";
import { Parser as v } from "./ghl-ui.es1613.js";
import { parseNDigitsSigned as f } from "./ghl-ui.es1614.js";
import C from "./ghl-ui.es1604.js";
var P = /* @__PURE__ */ function(p) {
  c(i, p);
  var s = h(i);
  function i() {
    var r;
    u(this, i);
    for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
      t[a] = arguments[a];
    return r = s.call.apply(s, [this].concat(t)), m(n(r), "priority", 130), m(n(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return l(i, [{
    key: "parse",
    value: function(e, t) {
      return t === "R" ? f(4, e) : f(t.length, e);
    }
  }, {
    key: "set",
    value: function(e, t, a) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(a, 0, 4), o.setUTCHours(0, 0, 0, 0), C(o);
    }
  }]), i;
}(v);
export {
  P as ISOWeekYearParser
};
